import { Separator } from "@/marketing/components/ui/separator";
import { useListStore } from "@/marketing/stores/useListStore";
import { ListSelector } from "./ListSelector";
import type { TabId } from "@/marketing/models/influencer";

interface TabBarProps {
  selectedCount: number;
  rejectedCount: number;
}

interface TabButtonProps {
  tab: TabId;
  label: string;
  count?: number;
  active: boolean;
  onClick: () => void;
}

function TabButton({ label, count, active, onClick }: TabButtonProps) {
  return (
    <button
      type="button"
      className={`tw-relative tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-h-10 tw-text-sm tw-font-medium tw-transition-colors ${
        active
          ? "tw-text-foreground"
          : "tw-text-muted-foreground hover:tw-text-foreground"
      }`}
      onClick={onClick}
    >
      {label}
      {count !== undefined && count > 0 && (
        <span
          className={`tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-px-1.5 tw-py-0.5 tw-text-[10px] tw-font-semibold tw-leading-none ${
            label === "Selected"
              ? "tw-bg-emerald-100 tw-text-emerald-700"
              : "tw-bg-neutral-100 tw-text-neutral-600"
          }`}
        >
          {count}
        </span>
      )}
      {active && (
        <span className="tw-absolute tw-bottom-0 tw-left-3 tw-right-3 tw-h-0.5 tw-rounded-full tw-bg-[#2563EB]" />
      )}
    </button>
  );
}

export function TabBar({ selectedCount, rejectedCount }: TabBarProps) {
  const activeTab = useListStore((s) => s.activeTab);
  const setActiveTab = useListStore((s) => s.setActiveTab);

  return (
    <div className="tw-flex tw-items-center tw-h-10 tw-border-b tw-px-8">
      <ListSelector />
      <Separator orientation="vertical" className="tw-mx-3 tw-h-5" />
      <TabButton
        tab="discover"
        label="Discover"
        active={activeTab === "discover"}
        onClick={() => setActiveTab("discover")}
      />
      <TabButton
        tab="selected"
        label="Selected"
        count={selectedCount}
        active={activeTab === "selected"}
        onClick={() => setActiveTab("selected")}
      />
      <TabButton
        tab="rejected"
        label="Rejected"
        count={rejectedCount}
        active={activeTab === "rejected"}
        onClick={() => setActiveTab("rejected")}
      />
    </div>
  );
}
